import React, { useEffect, useState } from "react";

import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";

interface ICustomOneMap {
  center: any;
  onMapClick?: (data: { lat: number; lng: number }) => void;
}

const MapHandler = ({ center, onMapClick }: ICustomOneMap) => {
  const [marker, setMarker] = useState({
    lat: center.lat,
    lng: center.lng,
  });

  useEffect(() => {
    setMarker({
      lat: center.lat,
      lng: center.lng,
    });
  }, [center]);

  useMapEvents({
    click(e) {
      if (onMapClick) {
        const newMarker = e.latlng;
        onMapClick(newMarker);
        setMarker(newMarker);
      }
    },
  });

  return <Marker position={marker}></Marker>;
};

const OneMap = ({ center, onMapClick }: ICustomOneMap) => {
  return (
    <MapContainer
      style={{ height: "40vh", width: "100%" }}
      center={center}
      zoom={15}
    >
      <TileLayer
        attribution='<img src="https://www.onemap.gov.sg/web-assets/images/logo/om_logo.png" style="height:20px;width:20px;"/> OneMap | Map data &copy; contributors, <a href="https://www.sla.gov.sg/">Singapore Land Authority</a>'
        url="https://www.onemap.gov.sg/maps/tiles/Default/{z}/{x}/{y}.png"
        detectRetina
        maxZoom={19}
        minZoom={11}
      />
      <MapHandler center={center} onMapClick={onMapClick} />
    </MapContainer>
  );
};

export default OneMap;
